import { ReportRecord } from "./report-payload";

export interface VehicleEntry {
  vehicle: {
    name : string;
    imei : string
  };
  records: ReportRecord[];
  summary?: VehicleSummary | any;
}
export type VehicleReportData = {
  vehicles : VehicleEntry[]
};

export type BasicReportData = {
  records: ReportRecord[];
}

export type VehicleSummary = {
  routeLength?: any;        // longitudRuta
  movingDuration?: any;     // duracionMovimiento
  stoppedDuration?: any;    // duracionDetenido
  maxSpeed?: any;           // velocidadMasAlta
  avgSpeed?: any;           // velocidadPromedio

  gpsSpeeding?: any;         // execesosVelocidadGPS
  ecoSpeeding?: any;         // execesosVelocidadECO
  canSpeeding?: any;         // execesosVelocidadCAN
  totalFatigue?: any;        // totalFatigas
  hardBraking?: any;         // frenadaBrusca
  highRpm?: any;             // rpmAlta
  alcohol?: any;             // alcoholemia

  distanceTraveled?: any;     // distanciaRecorrida
  fuelConsumed?: any;         // combustibleConsumido
  hrfFuelConsumed?: any;      // combustibleHRFCConsumido
  gallonPerformance?: any;    // rendimientoGalon
};

export const VehicleSummaryHeaders: { [key in keyof VehicleSummary | string]: string } = {
  routeLength: 'Longitud de Ruta',
  movingDuration: 'Duración en Movimiento',
  stoppedDuration: 'Duración Detenido',
  maxSpeed: 'Velocidad Máxima',
  avgSpeed: 'Velocidad Promedio',

  gpsSpeeding: 'Excesos de Velocidad GPS',
  ecoSpeeding: 'Excesos de Velocidad ECO',
  canSpeeding: 'Excesos de Velocidad CAN',
  totalFatigue: 'Total de Fatigas',
  hardBraking: 'Frenadas Bruscas',
  highRpm: 'RPM Alta',

  distanceTraveled: 'Distancia Recorrida',
  fuelConsumed: 'Combustible Consumido',
  hrfFuelConsumed: 'Combustible HRFC Consumido',
  gallonPerformance: 'Rendimiento por Galón',
};
